import Link from "next/link";
import { FC } from "react";
import SLiderTitleSkeleton from "./SlidertitleSkeleton";
import { Button } from "legacy/stories";

interface Props {
  isLoadingTitle?: boolean;
  title?: string;
  viewAllLink?: string;
}

const LandingSLiderTitle: FC<Props> = ({
  isLoadingTitle,
  title,
  viewAllLink,
}) => {
  const viewAllLinkBtn = isLoadingTitle ? "#" : (viewAllLink as string);
  return (
    <div className="flex justify-between">
      <span className="text-zinc-700 md:font-bold font-medium  md:text-lg text-base">
        {isLoadingTitle ? <SLiderTitleSkeleton /> : title}
      </span>
      {(viewAllLink || isLoadingTitle) && (
        <Link href={viewAllLinkBtn}>
          <Button
            mode="noneStyle"
            label="مشاهده همه"
            size="medium"
            className="text-primary !m-0 md:font-medium font-normal md:text-base text-sm  !p-0 my-3"
          />
        </Link>
      )}
    </div>
  );
};

export default LandingSLiderTitle;
